<div class="w-full py-6">
  @if (isLoading()) {
<div class="min-h-[200px] w-auto mx-auto flex items-center justify-center">
  <div class="flex flex-col items-center gap-4">
    <div
      class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-g300"
    ></div>
    <p class="text-text-primary font-poppins text-base">
      Cargando formulario...
    </p>
  </div>
</div>
  } 
  @else if (formData && formData.length > 0) {
  @if (showViewToggle) {
  <div class="mb-6 flex justify-center">
    <app-precredit-toogle [firstOption]="toggleOptionWeb" [secondOption]="toggleOptionMobile" (optionChanged)="onTypeChange($event)"></app-precredit-toogle>
  </div>
  }

  @if (formData.length > 1) {
  <!-- Multiple forms with tabs -->
  <tabs [enablePadding]="false">
    @for (form of formData; track form._id; let formIndex = $index) {
    <tab [label]="form.applicantType === 'individual' ? 'Persona individual' : 'Persona jurídica'">
      @if(viewType === 'mobile') {
      <div class="flex flex-col items-start p-4 gap-2 w-[390px] h-[94px] bg-[#E0EDFF] rounded-2xl flex-none self-stretch mt-6">
        <div class="flex flex-row items-start gap-4 self-stretch">
          <div class="w-6 h-6 flex-none">
            <i class="fi fi-sr-exclamation text-2xl text-[#5598F6]"></i>
          </div>
          <div class="flex flex-col items-start gap-1 flex-grow">
            <p class="font-lexend font-semibold text-base leading-[18px] text-[#105FCE] self-stretch">Vista simulada de smartphone (390 px)</p>
            <p class="font-poppins font-medium text-sm leading-5 text-[#1A212B] self-stretch">No representa cambios en la configuración real del formulario.</p>
          </div>
        </div>
      </div>
    }
    <div class="form-content pt-6">
      <!-- Form Header -->
      @if (showFormHeader) {
      <div class="mb-6 pb-4 border-b-2 border-primary-g300" [ngClass]="viewType === 'mobile' || !form.imageUrl ? 'text-center' : 'flex gap-6 items-start'">
          @if(form.imageUrl) {
            <img [src]="form.imageUrl" alt="info icon" class="rounded-xl object-contain" [ngClass]="viewType === 'mobile' ? 'inline-block mb-2 w-[144px] h-[72px]' : 'flex-shrink-0 w-[144px] h-[72px]'" />
            }
            <div [ngClass]="viewType === 'mobile' || !form.imageUrl ? '' : 'flex-1 text-left'">
              <h1 [ngClass]="viewType === 'mobile' ? 'text-[16px]' : 'text-[22px]'" class="leading-6 font-semibold text-text-primary mb-2">Formulario de solicitud - {{
                form.formName }}</h1>
              <p class="text-sm font-medium leading-5 text-text-primary mb-2">{{ form.productName }}</p>
              <p class="text-sm text-text-secondary leading-5">{{ form.description }}</p>

            </div>
        </div>
        }

        @if((form.applicantType === 'individual' && individualIncomplete()) || (form.applicantType === 'legal_entity' && legalIncomplete())) {
        <div class="flex items-center bg-warning-200 rounded-2xl p-4 mb-4 xs:mb-6 -mt-2">
        <i class="fi fi-sr-exclamation text-xl text-warning flex items-center"></i>
        <p class="text-sm text-text-primary font-poppins font-medium ml-3">
          El formulario para {{ form.applicantType === 'individual' ? 'persona individual' : 'persona jurídica' }} aún no está configurado completamente. Regresa al builder para finalizar su construcción.
        </p>
      </div>

        }

        <!-- Form -->
        <form [formGroup]="formGroups[formIndex]" (ngSubmit)="onSubmit(formIndex)">
          <!-- Sections -->
          @for (section of form.sections; track section.order) {
          <div class="mb-6 bg-white rounded-2xl border border-soft-gray-outline p-4">
            <!-- Section Header -->
            <div class="mb-3">
              <h2 class="text-[16px] text-text-primary leading-6 font-semibold mb-1">{{ section.title }}</h2>
              @if (section.description) {
              <p class="text-text-secondary leading-5 text-sm">{{ section.description }}</p>
              }
            </div>

            <!-- Fields -->
            @if (section.fields && section.fields.length > 0) {
            <div [class]="responsive ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : (viewType === 'mobile' ? 'grid grid-cols-1 gap-4' : 'grid grid-cols-2 gap-4')">
              @for (field of getSortedFields(section.fields); track $index) {
              <div
                [class]="responsive ? (shouldOccupyFullRow(field, section.fields) ? 'w-full md:col-span-2' : 'w-full') : (viewType === 'web' && shouldOccupyFullRow(field, section.fields) ? 'w-full col-span-2' : 'w-full')">
                @if (isPhoneField(field) && getTenantIsoCode()) {
                <phone-input [control]="getControl(formIndex, field.fieldId)!" [isoCode]="getTenantIsoCode()"
                  [fallbackLabel]="field.label | fieldLabel: field.originalName" [isRequired]="field.isMandatory"></phone-input>
                } @else {
                <input-generator [label]="field.label | fieldLabel: field.originalName" [dataType]="field.dataType"
                  [placeholder]="field.metadata?.placeholder || 'Ingresar'" [options]="field.metadata?.options || []"

                  [control]="getControl(formIndex, field.fieldId)!" [useOverlayForList]="true"></input-generator>
                }
              </div>
              }
            </div>
            } @else {
            <p class="text-sm text-text-secondary leading-5 italic">Esta sección no contiene campos configurados.</p>
            }
          </div>
          }

          <!-- Footer -->
          @if (form.footer && form.footer.length > 0) {
              <div class="mb-6 bg-white rounded-2xl border border-soft-gray-outline p-4">
            <div class="mb-6 space-y-3">
              @for (footerItem of getSortedFooter(form.footer); track footerItem.order; let i = $index) {
              @if (footerItem.type === 'consent') {
              <div
                class="flex flex-row  items-center p-3 gap-3 bg-[#F6F8FB] border border-[#CBD4E1] rounded-lg">
               <app-checkbox type="checkbox" [label]="'consent_' + footerItem.order" 
                        [formControlName]="'consent_' + footerItem.order"
                        class="text-primary-g300 border-gray-300 rounded focus:ring-primary-g300">
                        <div class="flex flex-col justify-center items-start p-0 gap-1 flex-grow">
                            <div class="flex flex-col justify-center items-start p-0 w-full">
                                <p class="font-medium text-sm leading-5 text-[#1A212B] cursor-pointer w-full">
                                    {{ footerItem.content }}
                                    @if (footerItem.required) {
                                    <span class="text-red-500">*</span>
                                    }
                                </p>
                                @if (footerItem.link) {
                                <a [href]="footerItem.link" target="_blank"
                                    class="font-normal text-xs leading-[18px] underline text-[#105FCE] w-full">
                                    Ver documento
                                </a>
                                }
                            </div>
                        </div>
                    </app-checkbox>
            </div>
              } @else if (footerItem.type === 'text') {
              <div class="text-text-primary" [innerHTML]="sanitizeHtml(footerItem.content)"></div>
              }
              }
            </div>
          </div>
            }

          <!-- Submit Button -->
          @if (showSubmitButton) {
          <div class="flex justify-center">
            <button type="submit" [disabled]="disableSubmission || formGroups[formIndex].invalid || (form.applicantType === 'individual' ? individualIncomplete() : legalIncomplete())"
              class="flex flex-row justify-center items-center px-4 py-3 gap-3 w-[171px] h-12 rounded-2xl font-medium text-base leading-6 transition-colors"
              [ngClass]="{
                      'bg-primary-g300 text-white hover:bg-primary-g400': !disableSubmission && formGroups[formIndex].valid && !(form.applicantType === 'individual' ? individualIncomplete() : legalIncomplete()),
                      'cursor-not-allowed': disableSubmission || formGroups[formIndex].invalid || (form.applicantType === 'individual' ? individualIncomplete() : legalIncomplete())
                    }" [style.background]="(disableSubmission || formGroups[formIndex].invalid || (form.applicantType === 'individual' ? individualIncomplete() : legalIncomplete())) ? 'rgba(203, 212, 225, 0.2)' : null"
              [style.color]="(disableSubmission || formGroups[formIndex].invalid || (form.applicantType === 'individual' ? individualIncomplete() : legalIncomplete())) ? 'rgba(154, 168, 188, 0.3)' : null">
              Enviar formulario
            </button>
          </div>
          }
        </form>
      </div>
    </tab>
    }
  </tabs>
  } @else {
  <!-- Single form without tabs -->
  @if (formData[0]) {
  @if(viewType === 'mobile') {
  <div class="flex flex-col items-start p-4 gap-2 w-[390px] h-[94px] bg-[#E0EDFF] rounded-2xl flex-none self-stretch mt-6">
    <div class="flex flex-row items-start gap-4 self-stretch">
      <div class="w-6 h-6 flex-none">
        <i class="fi fi-sr-exclamation text-2xl text-[#5598F6]"></i>
      </div>
      <div class="flex flex-col items-start gap-1 flex-grow">
        <p class="font-lexend font-semibold text-base leading-[18px] text-[#105FCE] self-stretch">Vista simulada de smartphone (390 px)</p>
        <p class="font-poppins font-medium text-sm leading-5 text-[#1A212B] self-stretch">No representa cambios en la configuración real del formulario.</p>
      </div>
    </div>
  </div>
  }
  <div class="form-content pt-6">
    <!-- Form Header -->
    @if (showFormHeader) {
    <div class="mb-6 pb-4 border-b-2 border-primary-g300" [ngClass]="viewType === 'mobile' || !formData[0].imageUrl ? 'text-center' : 'flex gap-6 items-start'">
      @if(formData[0].imageUrl) {
        <img [src]="formData[0].imageUrl" alt="info icon" class="rounded-xl object-contain" [ngClass]="viewType === 'mobile' ? 'inline-block mb-2 w-[144px] h-[72px]' : 'flex-shrink-0 w-[144px] h-[72px]'" />
      }
      <div [ngClass]="viewType === 'mobile' || !formData[0].imageUrl ? '' : 'flex-1 text-left'">
        <h1 [ngClass]="viewType === 'mobile' ? 'text-[16px]' : 'text-[22px]'" class="leading-6 font-semibold text-text-primary mb-2">Formulario de solicitud - {{
          formData[0].formName }}</h1>
        <p class="text-sm font-medium leading-5 text-text-primary mb-2">{{ formData[0].productName }}</p>
        <p class="text-sm text-text-secondary leading-5">{{ formData[0].description }}</p>
      </div>
    </div>
    }

    @if((formData[0].applicantType === 'individual' && individualIncomplete()) || (formData[0].applicantType === 'legal_entity' && legalIncomplete())) {
    <div class="flex items-center bg-warning-200 rounded-2xl p-4 mb-4 xs:mb-6 -mt-2">
    <i class="fi fi-sr-exclamation text-xl text-warning flex items-center"></i>
    <p class="text-sm text-text-primary font-poppins font-medium ml-3">
      El formulario para {{ formData[0].applicantType === 'individual' ? 'persona individual' : 'persona jurídica' }} aún no está configurado completamente. Regresa al builder para finalizar su construcción.
    </p>
  </div>

    }

    <!-- Form -->
    <form [formGroup]="formGroups[0]" (ngSubmit)="onSubmit(0)">
      <!-- Sections -->
      @for (section of formData[0].sections; track section.order) {
      <div class="mb-6 bg-white rounded-2xl border border-soft-gray-outline p-4">
        <!-- Section Header -->
        <div class="mb-3">
          <h2 class="text-[16px] text-text-primary leading-6 font-semibold mb-1">{{ section.title }}</h2>
          @if (section.description) {
          <p class="text-text-secondary leading-5 text-sm">{{ section.description }}</p>
          }
        </div>

        <!-- Fields -->
        @if (section.fields && section.fields.length > 0) {
        <div [class]="responsive ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : (viewType === 'mobile' ? 'grid grid-cols-1 gap-4' : 'grid grid-cols-2 gap-4')">
          @for (field of getSortedFields(section.fields); track $index) {
          <div
            [class]="responsive ? (shouldOccupyFullRow(field, section.fields) ? 'w-full md:col-span-2' : 'w-full') : (viewType === 'web' && shouldOccupyFullRow(field, section.fields) ? 'w-full col-span-2' : 'w-full')">
            @if (isPhoneField(field) && getTenantIsoCode()) {
            <phone-input [control]="getControl(0, field.fieldId)!" [isoCode]="getTenantIsoCode()"
              [fallbackLabel]="field.label | fieldLabel: field.originalName" [isRequired]="field.isMandatory"></phone-input>
            } @else {
            <input-generator [label]="field.label | fieldLabel: field.originalName" [dataType]="field.dataType"
              [placeholder]="field.metadata?.placeholder || 'Ingresar'" [options]="field.metadata?.options || []"
              [control]="getControl(0, field.fieldId)!" [useOverlayForList]="true"></input-generator>
            }
          </div>
          }
        </div>
        } @else {
        <p class="text-sm text-text-secondary leading-5 italic">Esta sección no contiene campos configurados.</p>
        }
      </div>
        }

      <!-- Footer -->
      @if (formData[0].footer && formData[0].footer.length > 0) {
          <div class="mb-6 bg-white rounded-2xl border border-soft-gray-outline p-4">
        <div class="mb-6 space-y-3">
          @for (footerItem of getSortedFooter(formData[0].footer); track footerItem.order; let i = $index) {
          @if (footerItem.type === 'consent') {
          <div
                class="flex flex-row  items-center p-3 gap-3 bg-[#F6F8FB] border border-[#CBD4E1] rounded-lg">
               <app-checkbox type="checkbox" [label]="'consent_' + footerItem.order" 
                        [formControlName]="'consent_' + footerItem.order"
                        class="text-primary-g300 border-gray-300 rounded focus:ring-primary-g300">
                        <div class="flex flex-col justify-center items-start p-0 gap-1 flex-grow">
                            <div class="flex flex-col justify-center items-start p-0 w-full">
                                <p class="font-medium text-sm leading-5 text-[#1A212B] cursor-pointer w-full">
                                    {{ footerItem.content }}
                                    @if (footerItem.required) {
                                    <span class="text-red-500">*</span>
                                    }
                                </p>
                                @if (footerItem.link) {
                                <a [href]="footerItem.link" target="_blank"
                                    class="font-normal text-xs leading-[18px] underline text-[#105FCE] w-full">
                                    Ver documento
                                </a>
                                }
                            </div>
                        </div>
                    </app-checkbox>
            </div>
          } @else if (footerItem.type === 'text') {
          <div [innerHTML]="sanitizeHtml(footerItem.content)"></div>
          }
          }
        </div>
      </div>
        }

      <!-- Submit Button -->
      @if (showSubmitButton) {
      <div class="flex justify-center">
        <button type="submit" [disabled]="disableSubmission || formGroups[0].invalid || (formData[0].applicantType === 'individual' ? individualIncomplete() : legalIncomplete())"
          class="flex flex-row justify-center items-center px-4 py-3 gap-3 w-[171px] h-12 rounded-2xl font-medium text-base leading-6 transition-colors"
          [ngClass]="{
                  'bg-primary-g300 text-white hover:bg-primary-g400': !disableSubmission && formGroups[0].valid && !(formData[0].applicantType === 'individual' ? individualIncomplete() : legalIncomplete()),
                  'cursor-not-allowed': disableSubmission || formGroups[0].invalid || (formData[0].applicantType === 'individual' ? individualIncomplete() : legalIncomplete())
                }" [style.background]="(disableSubmission || formGroups[0].invalid || (formData[0].applicantType === 'individual' ? individualIncomplete() : legalIncomplete())) ? 'rgba(203, 212, 225, 0.2)' : null"
          [style.color]="(disableSubmission || formGroups[0].invalid || (formData[0].applicantType === 'individual' ? individualIncomplete() : legalIncomplete())) ? 'rgba(154, 168, 188, 0.3)' : null">
          Enviar formulario
        </button>
      </div>
      }
    </form>
  </div>
  }
  }
  }
  @else {
    <empty-state-card
    title="No hay formularios disponibles"
    icon="svg/empty-state-icon.svg"
  >
  </empty-state-card>
  }
</div>